module.exports = __webpack_public_path__ + "static/media/tesila.1b5f7c42.PNG";